// extensions/DiffMark.ts
import { Mark, mergeAttributes } from "@tiptap/core"

/* ---------- 공통 스타일 ---------- */
const baseStyle = {
  added:  "background-color:#d4f5e0;color:#22543d;border-radius:4px;padding:0 2px;",
  removed:"background-color:#fed7d7;color:#742a2a;border-radius:4px;padding:0 2px;text-decoration:line-through;",
}

/* ---------- 공통 attribute 선언 ---------- */
const attributeSpec = {
  diffId: {
    default: null,
    parseHTML: (element: HTMLElement) => element.getAttribute("data-diff-id") || null,
    renderHTML: (attrs: { diffId?: string | null }) =>
      attrs.diffId ? { "data-diff-id": attrs.diffId } : {},
  },
}

/* ---------- diffAdded ---------- */
export const DiffAdded = Mark.create({
  name: "diffAdded",

  addAttributes() {
    return attributeSpec
  },

  parseHTML() {
    return [{ tag: "span[data-diff='added']" }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-diff": "added",
        style: baseStyle.added,
      }),
      0,
    ]
  },
})

/* ---------- diffRemoved ---------- */
export const DiffRemoved = Mark.create({
  name: "diffRemoved",

  addAttributes() {
    return attributeSpec
  },

  parseHTML() {
    return [{ tag: "span[data-diff='removed']" }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-diff": "removed",
        style: baseStyle.removed,
      }),
      0,
    ]
  },
})
